<svg [style.width]="width" [style.height]="height">
  <use [attr.xlink:href]="'/assets/icons/sprites.svg#' + name"></use>
</svg>
